import { SectionList } from './SectionList';
import { Wrapper } from './StudyStatus.styles';
import { StudySummary } from './StudySummary';

export const StudyStatus = () => {
  return (
    <Wrapper>
      <StudySummary />
      <SectionList />
    </Wrapper>
  );
};
